import { Component, input } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { DataSources } from '../data-sources';
import { EpsChart } from '../eps-chart/eps-chart';
import { RevenueChart } from '../revenue-chart/revenue-chart';
import { TimeAgo } from '../time-ago/time-ago';
import { CountUp } from '../count-up/count-up';
import { V3NotchCard } from '../v3-notch-card/v3-notch-card';
import { earningsAnalysisData } from '../services/earnings-analysis-data';

// Zero/finnetWeb desktop EPS + revenue columns, shared by V3EarningsOverview (main-page card) and
// V3EarningsAnalysis (detail sub-page, which projects its own blocks below each column). See
// CLAUDE.md.
@Component({
  selector: 'app-v3-earnings-desktop-content',
  imports: [NgTemplateOutlet, EpsChart, RevenueChart, TimeAgo, CountUp, V3NotchCard],
  standalone: true,
  templateUrl: './v3-earnings-desktop-content.html',
  styleUrl: './v3-earnings-desktop-content.scss',
})
export class V3EarningsDesktopContent {
  // Detail sub-page: finnetWeb keeps the stat rows top-pinned; the overview card bottom-pins them.
  readonly isDetail = input(false);

  private readonly data = earningsAnalysisData();

  readonly dataSources = DataSources;
  readonly isFinnet = this.data.isFinnet;
  readonly updatedAt = this.data.updatedAt;
  readonly epsData = this.data.epsData;
  readonly epsSymbol = this.data.epsSymbol;
  readonly fiscalPeriod = this.data.fiscalPeriod;
  readonly quarterSurprisePercent = this.data.quarterSurprisePercent;
  readonly quarterSurpriseBeat = this.data.quarterSurpriseBeat;
  readonly revenueStats = this.data.revenueStats;
  readonly nextEarningsDate = this.data.nextEarningsDate;
  readonly isEarningsDateEnabled = this.data.isEarningsDateEnabled;
  readonly nextEarningsReportLabel = this.data.nextEarningsReportLabel;
}
